import { EInternalNoteType } from '@constants';

import { defaultTheme } from '@/styles';

export const getInternalNoteTypeTagStyles = (type: EInternalNoteType) => {
  const { colors } = defaultTheme;
  if (type === EInternalNoteType.PROGRESS)
    return {
      textColor: colors.green7,
      backgroundColor: colors.green1,
      borderColor: colors.green4
    };
  if (type === EInternalNoteType.NON_ATTENDANCE)
    return {
      textColor: colors.orange8,
      backgroundColor: colors.orange2,
      borderColor: colors.orange4
    };
  if (type === EInternalNoteType.INCIDENT)
    return {
      textColor: colors.red7,
      backgroundColor: colors.red2,
      borderColor: colors.red4
    };
  return {
    textColor: colors.black9,
    backgroundColor: colors.black2,
    borderColor: colors.black3
  };
};
